import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';
import "../../css/course-page.css";
class Certificateinadvanceexcel extends Component {
    render() {
        return (
            <div>

                    <div aria-label="breadcrumb">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                        <li class="breadcrumb-item active" aria-current="page">Certificate Course  in Advance Excel</li>
                    </ol>
                    </div>

                    <section class="course-header excel-color" id="course-header">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5 six-sigma-bkg">
                                <h1>Certificate Course  in Advance Excel<br /></h1><br /><br />
                                <p>Accelerate your Career. Stay Ahead of the Curve </p>
                                <br /><br /><br />

                     <div class="form-group">
                        <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>
                       
                      <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                           data-target="#myModal" onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/certificate-course-in-advance-excel');">Download
                        brochure</button> <br /><br />
                     
                     </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                  <p>Jointly Delivered by eduplusnow and Industry Expert </p>
                     <br />
                     <table class="table-highlight">
                        <tr>
                           <td> <img alt="executive2" width="" src="/assets/images/epn.svg" /></td>
                        </tr>
                     </table>
                     <br />
                  </div>
               </div>
               <div class="br-hide-mobile"> <br /> <br /> </div>
            </section>
          
            <div class="course-main-contains def-z">
                <div class="card" id="Description">
                    <div class="row contanint-display">
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;24 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>  
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;24 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp; WEEKEND BATCH</b>
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" >    
                       
                        </div>
                    </div>
                </div>
            </div>
            <section class="def-z">
            <div class="header" id="myHeader">
                    <ul>
                        <li><a href="#Description">Description</a></li>
                        <li><a href="#Role">Job Role</a></li>
                        <li><a href="#tools">Tools</a></li>
                        <li><a href="#syllabus">Syllabus</a></li>               
                        <li><a href="#Outcomes">Learning Outcomes</a></li>           
                        <li><a href="#Review">Learner Review</a></li>          
                        <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>           
                    </ul>
            </div>
            </section>
           
            <section class="course-description " id="course-description">
               <br />
               <div class="row">
                  <div class="col-sm-12">
                     <h3  >About Advanced Excel </h3>
                     <p align = "justify">Advanced Excel training will expertise individual in spreadsheet capabilities, spreadsheet operations using tools, functions, diagrams etc.</p>
                  </div>
               
               </div>
              
               <br />
               <div class="row">
                  <div class="col-sm-12">
                     <h4>Course Features</h4>
                     <p align = "justify">In detail coverage of Excel functions, reports, Lookups ,pivot tables etc.</p>
                  </div>
               </div>
               <br />
               <div class="row">
                  <div class="col-sm-6">
                     <h5  id="Role"> Who Should Enroll? </h5>
                     <ul class="admission-ul">
                        <li>Ideal for any Graduate, professionals from Banking, MIS, Back office, fiance MBA in any domain.</li>
                     </ul>
                  </div><div class="col-sm-6">
                     <h5> Eligibility </h5>
                     <ul class="admission-ul">
                        <li>There are no pre requisites for Advance Excel training.</li>
                     </ul>
                  </div>
               </div>
            </section>

            <section class="course-industry-trends bg-secondary" id="course-industry-trends">
            <h5 id="tools">Job Roles</h5>
               <br />
               <div class="row">
                  <div class="col-md-3 col-sm-12 job-role-text">
                     <i class="fa fa-database btn-title-excel link-icon-excel" aria-hidden="true"></i>&nbsp;Data Analyst
                  </div>
                  <div class="col-md-3 col-sm-12 job-role-text">
                     <i class="fa fa-user btn-title-excel link-icon-excel" aria-hidden="true"></i>&nbsp;MIS Executive
                  </div>
                  <div class="col-md-3 col-sm-12 job-role-text">
                     <i class="fa fa-graduation-cap btn-title-excel link-icon-excel" aria-hidden="true"></i>&nbsp;Sr MIS Executive
                  </div>
               </div>
            </section> 
            <br /> 
            <section class="course-tools-covered" >
               <h3> Tools Covered </h3>
               <br />
               <div class="row">
                     <div class="col-md-3 col-sm-12">
                        <div class="card cards-singles" >
                        <center id="syllabus">
                            <img alt="excel-logo" src="/assets/images/icons/excel-logo.png" /> </center>
                     </div>
                  </div>
               </div>
            </section>
         
            <section class="course-syllabus" id="course-syllabus">
            <div class="row" >
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                     <br />
                     <h3> Syllabus </h3>
                     <br />
                     <div class="syl-bg">
                     <h5>Advanced Excel  </h5>
                     <div id="de_syllabus">
                        <div class="panel-group">
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                                 href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>  Basic Excel Environment
                                 </h6>
                              </div>
                              <div id="de_syllabus1" class="collapse show" aria-labelledby="de_heading1"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Main Features and advantages of Excel – Overview </li>
                                    <li> Workbook, worksheets structure </li>
                                    <li> Options settings and configurations </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                          
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading2" data-toggle="collapse"
                                 href="#de_syllabus2" aria-expanded="true" aria-controls="de_syllabus2">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Working with Functions 
                                 </h6>
                              </div>
                              <div id="de_syllabus2" class="collapse show" aria-labelledby="de_heading2"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Using the Paste Function tool </li> 
                                    <li> Cell Ref/Freezing Concept </li>
                                    <li> Using Named Ranges in Formulas </li>
                                    <li> Naming a Single Cell </li>
                                    <li> Naming a Range of Cells </li>
                                    <li> Naming Multiple Single Cells Quickly </li>
                                    <li> Using Formulas That Span Multiple Worksheets </li>
                                    <li> Using the IF Function </li>
                                    <li> Using AND/OR Functions </li>
                                    <li> Using the SUMIF, AVERAGEIF, and COUNTIF Functions </li>
                                    <li> Using the LOOKUP Function </li>
                                    <li> Using the VLOOKUP Function </li>
                                    <li> Using the HLOOKUP Function </li>
                                    <li> Using the CONCATENATE Function </li>
                                    <li> Using the TRANSPOSE Function </li>
                                    <li> Using the PROPER, UPPER, and LOWER Functions </li>
                                    <li> Using Max, Min, Large, Small </li>
                                    <li> The TRIM Function </li>
                                    <li> Text To Column </li> 
                                    <li> Using Date Functions </li> 
                                    <li> Using the NOW and TODAY Functions </li>
                                    <li> Conditional Formatting </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading3" data-toggle="collapse"
                                 href="#de_syllabus3" aria-expanded="true" aria-controls="de_syllabus3">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Working with Data 
                                 </h6>
                              </div>
                              <div id="de_syllabus3" class="collapse show" aria-labelledby="de_heading3"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li>Using Excel as a database</li>
                                    <li>Sorting Data</li> 
                                    <li>Custom sorts</li>
                                    <li>Filtering using AutoFilter</li>
                                    <li>The Advanced Filter tool</li> 
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="de_heading4" data-toggle="collapse"
                                 href="#de_syllabus4" aria-expanded="true" aria-controls="de_syllabus4">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Working with External Data 
                                 </h6>
                              </div>
                              <div id="de_syllabus4" class="collapse show" aria-labelledby="de_heading4"
                                 data-parent="#de_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Data consolidation </li> 
                                    <li> Linking to another workbook </li>
                                    <li> Linking to an external database </li>
                                    <li> Getting data from the web </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                        
                        </div>
                       
                     </div>
                    
                     <div id="damldl_syllabus">
                        <div class="panel-group">
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading7" data-toggle="collapse"
                                 href="#damldl_syllabus7" aria-expanded="true" aria-controls="damldl_syllabus7">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Charting with Excel 
                                 </h6>
                              </div>
                              <div id="damldl_syllabus7" class="collapse show" aria-labelledby="damldl_heading7"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul">
                                    <li> Selecting the data to chart </li>
                                    <li> Creating a chart </li>
                                    <li> Choosing the right chart for the job </li>
                                    <li> Moving and re-sizing charts </li>
                                    <li> Customizing charts </li> 
                                    <li> Saving and copying a chart's design </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading8" data-toggle="collapse"
                                 href="#damldl_syllabus8" aria-expanded="true" aria-controls="damldl_syllabus8">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Tables
                                 </h6>
                              </div>
                              <div id="damldl_syllabus8" class="collapse show" aria-labelledby="damldl_heading8"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul"> 
                                    <li> Creating an Excel table </li>
                                    <li> Table formatting </li>
                                    <li> Adding rows and columns </li>
                                    <li> Automatic calculation in tables </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                         
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading9" data-toggle="collapse"
                                 href="#damldl_syllabus9" aria-expanded="true" aria-controls="damldl_syllabus9">
                                 <h6 class="panel-title">
                                   <i class="indicator fa fa-minus"></i> Collaboration Tools
                                 </h6>
                              </div>
                              <div id="damldl_syllabus9" class="collapse show" aria-labelledby="damldl_heading9"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul"> 
                                       <li> Protecting a workbook </li>
                                       <li> Protecting worksheets and cells </li>
                                       <li> Adding comments to cells </li>
                                       <li> Sharing workbooks </li>
                                       <li> Tracking changes </li>
                                       <li> Auditing Workbooks </li>
                                       <li> Viewing formulas </li>
                                       <li> Tracing precedents and dependents </li>
                                       <li> Error checking </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading10" data-toggle="collapse"
                                 href="#damldl_syllabus10" aria-expanded="true" aria-controls="damldl_syllabus10">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i>  Pivot Table
                                 </h6>
                              </div>
                              <div id="damldl_syllabus10" class="collapse show" aria-labelledby="damldl_heading10"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul"> 
                                   <li> Golden Rule of Pivot </li>
                                   <li>Create Pivot Table </li> 
                                   <li>Create multiple pages </li>
                                   <li>Classic pivot table </li>
                                   <li> Consolidate </li>
                                   <li> Merging Summary data from different sheets </li>
                                   <li> Merging Summary data from different files </li>
                                   <li> Merging non-summary data </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading11" data-toggle="collapse"
                                 href="#damldl_syllabus11" aria-expanded="true" aria-controls="damldl_syllabus11">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Templates
                                 </h6>
                              </div>
                              <div id="damldl_syllabus11" class="collapse show" aria-labelledby="damldl_heading11"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul"> 
                                    <li> Concept and advantage of templates </li>
                                    <li> Creating template </li>
                                    <li> Using the template </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading12" data-toggle="collapse"
                                 href="#damldl_syllabus12" aria-expanded="true" aria-controls="damldl_syllabus12">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> AddIns
                                 </h6>
                              </div>
                              <div id="damldl_syllabus12" class="collapse show" aria-labelledby="damldl_heading12"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul"> 
                                    <li> Difference between Addins and Templates </li>
                                    <li> Creating a AddIn </li>
                                    <li> Using a AddIn </li> 
                                    </ul>
                                 </div>
                              </div>
                           </div>
                           <div class="panel panel-info">
                              <div class="panel-heading" id="damldl_heading13" data-toggle="collapse"
                                 href="#damldl_syllabus13" aria-expanded="true" aria-controls="damldl_syllabus13">
                                 <h6 class="panel-title">
                                    <i class="indicator fa fa-minus"></i> Macros
                                 </h6>
                              </div>
                              <div id="damldl_syllabus13" class="collapse show" aria-labelledby="damldl_heading13"
                                 data-parent="#damldl_syllabus">
                                 <div class="panel-body">
                                    <ul class="syllabus-ul"> 
                                    <li id="Outcomes">   Concept and importance of Macro </li>
                                    <li>   Creating a macro </li>
                                    <li>   Running existing macros </li>
                                    <li>   Attaching Macro to Keyboard keys, Tool bar, Menu Bar or button-click </li>
                                    <li>   VBA Code overview </li>
                                    </ul>
                                 </div>
                              </div>
                           </div>   
                        </div>
                      
                     </div>   
                     </div> 
                     </div> 
               </div>
              
            </section>
          
            <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
               <div class="row">
                  <div class="col-sm-6">
                     <h3>Learning Outcomes</h3>
                     <ul class="lo-ul">
                        <li>By attending Advance Excel  training at eduplusnow you will become master Microsoft excel from begineer to advanced with common excel functions, Vlookups, Index, Match Fuctions and many more..
                        </li>
                     </ul>
                     <br />
                     <h5>Assessment </h5>
                     <p align="justify"  id="Review">
                     Periodic assessment and case studies evaluations by the edu plus now and Industry Expert have been built in throughout the duration of the course.
                     </p>
                  </div>
                  <div class="col-sm-6">
                     <img alt="datascience18"src="/assets/images/icons/certificate1.png" />
                     <p class="img-below-text text-center">Awarded by edu plus now 
                     </p>
                  </div>
               </div>
            </section>
           
            <section class="course-admission-process" id="course-admission-process1">

               <br />	 
             
            </section>
            <Aboutuslearners />     
            <Aluminicompany />
           
               <section class="courses-feesm">
            <section class="course-fees" id="course-fees">
            <div class="row box-sh" >
                   <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
                   
                    </div>
                    <div class="vertical-line-fee"> </div>
                    <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                        <div class="row">
                            <div class="col-sm-10"> <br /><br />
                                <h5>Features</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12">
                            Eduplusnow's Advanced Excel Training Course Will Master you in
                              <ul class="highlight-ss" >
                              <li>Options Settings And Configurations</li>
                              <li>Working with Functions in Excel</li>
                              <li>Working with Data using excel</li>
                              <li>Using Excel As A Database</li>
                              <li>Macros and Templates in excel</li>
                              <li>Collaboration Tools</li>
                              <li>Tables in excel</li>
                              <li>Charting with Excel</li>
                              </ul>
                            </div>
                            <p>{// eslint-disable-next-line
                            }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 "> &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                           </p>   
                           <p align = "justify" class="font-text-alumni" ><span>*</span>Alumni of Eduplusnow, VIT, VIIT, VU Will Get Special Discount, To Grab your Discount coupon Please Contact  &nbsp; <a href="tel://8956167195" class="contact-us-mobile"> <i class="fa fa-phone icon-tick"> </i>+918956167195. </a><br /></p>
                        </div> 
                        </div>
                </div>
             </section> 
             </section> 
             <Whyedu/>
            <section class="course-about-instructor bg-secondary " id="course-about-instructor">
            <div class="row">
            <div class="col-sm-12">
            <h3>
            About the Organization
            </h3>
            <br />
            <img alt="datascience23" width="200px" src="/assets/images/eduplusnow.png" />
            <br /><br />
            <p align="justify">edu plus now is an online educational platform that was launched in 2019 to bridge the skill gap between classroom learning, real business challenges and to help students achieve their career potential.
            </p>
            <br />
            <p align="justify">Aimed at providing learners with essential technical skills, edu plus now courses are created to be the perfect amalgamation of inputs from industry experts and highly-qualified professors from the country’s top educational institutions. This allows individuals and companies to close the skill gap quickly, innovate faster and achieve their key objectives. At edu plus now, we believe in preparing students for success in a changing world by providing online courses that pave the path for a successful career. Built under the aegis of the Vishwakarma Group, the online education platform provides flexible learning that fits a learner’s schedule. 
            </p>
            </div>
            </div>
            </section>
            <section class="course-faq" id="course-faq">
       
               <div class="row">
                  
               </div>
            </section>
        
         <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
            <div class="modal-dialog modal-md">
              
               <div class="modal-content">
                  <div class="modal-header" >
                     <span class="close" id="close_form"
                        data-dismiss="modal">&times;</span>
                     <br />
                  </div>
                  <div class="modal-body">
                     <div class="panel panel-default paper-shadow box_detail" >
                        <h5 class="text-center "> Download The Course Brochure </h5>
                        <form method="post" class="form-row"  onsubmit="return validate()">
                           <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                              required="" autocomplete="on" name="name" id="name" />
                           <b>Your email</b><input class="form-control" type="email" required=""
                              autocomplete="on" name="emaill" id="emaill" />
                           <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                              type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                           <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                           <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                           <br />
                           <div>
                              <div class="form-group">
                                 <div id="recaptcha" class="g-recaptcha"
                                    data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                 <div id="captcha"></div>
                              </div>
                           </div>
                         
                           <div class="mob_cb" >
                              <div>
                              </div>
                              <br />
                           
                              <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button>
                           </div>
                          
                           <br />
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>



            </div>
        );
    }
}

export default Certificateinadvanceexcel;